export class DynamicBrowserTitle {

    static $inject = ['store'];

    constructor(store) {
        this.store = store;
        this.unsubscribe = this.store.subscribe(() => {
            const menus = this.store.getState().menus;
            if (menus && menus.breadcrumb)
            {
                document.title = this.generateTitle(menus.breadcrumb);
            }
        });

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    }

    generateTitle(params) {
        let title = "";
        if (params) {
            const lenParams = Object.keys(params).length;
            Object.keys(params).forEach(function (key) {
                if (!(params[key].name === 'Projects' && lenParams > 1)) {
                    title += params[key].name + "/";
                }
            });
            title = title.slice(0, -1);
        }

        return (title);
    }
}



// WEBPACK FOOTER //
// ./src/utils/dynamic-browser-title.service.js